export const MIME_APPLICATION_PDF = 'application/pdf';

export const getDownloadableFile = (contenu, filename, mime) => {
    const mimeType = mime || 'application/octet-stream';
    let blobURL = contenu;
    if (contenu.match(/data:[\w/-]+;base64,/) === null) {
        blobURL = `data:${mimeType};base64,${contenu}`;
    }
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
};

export const getArrayFilesToSend = async (files) => {
    const filesToSend = [];
    for (let i = 0; i < files.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        filesToSend[i] = await files[i].getFileToSend();
    }

    return filesToSend;
};
